import {
  FRONTEGG_RESET_ACTIVATION_ENDPOINT,
  JSON_HEADERS
} from '@dtx-company/ithaca-sdk/src/frontegg/constants'
import { logger } from '@dtx-company/logger'

interface SendVerificationEmailServiceProps {
  email: string
}
type SendVerificationEmailService = (props: SendVerificationEmailServiceProps) => Promise<boolean>

const sendVerificationEmailService: SendVerificationEmailService = async ({ email }) => {
  try {
    const res = await fetch(FRONTEGG_RESET_ACTIVATION_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        email
      }),
      credentials: 'include',
      headers: JSON_HEADERS
    })

    if (res.ok) {
      return true
    } else throw new Error(`Unexpected response: ${res}`)
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
    return false
  }
}

export default sendVerificationEmailService
